import { render, staticRenderFns } from "./company-orders.vue?vue&type=template&id=12241607&"
import script from "./company-orders.ts?vue&type=script&lang=ts&"
export * from "./company-orders.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports